(function () {
  // --- CONFIGURATION ---
  const RUMP_VARIANT_ID = 41589553659949;
  const WAGYU_VARIANT_ID = 41589553823789;
  const DISCOUNTS = {
    RUMP: 'FREE_RUMP',
    WAGYU: 'FREE_WAGYU',
    OFF20: '20_OFF'
  };
  const PREFIX_RUMP = 'WBFREERUMP-';
  const PREFIX_WAGYU = 'WBFREEWAGYU-';
  const PREFIX_OFF20 = 'WB20OFF-';
  
  // Expiry: Wed 18 Feb 2026, 6:00 AM Melbourne
  const PROMO_END_TIME = Date.parse("2026-02-18T06:00:00+11:00");

  // --- STATE CONTROL ---
  let isWinbackRunning = false; // The Lock

  function is2026PromoExpired(code) {
    return (code === 'WB20OFF-2026' || code === 'WBFREEWAGYU-2026') && Date.now() > PROMO_END_TIME;
  }

  // --- INTERCEPTION ---
  const originalFetch = window.fetch;
  window.fetch = function () {
    return originalFetch.apply(this, arguments).then(async (response) => {
      const url = typeof arguments[0] === 'string' ? arguments[0] : arguments[0].url;
      if (url && url.includes('/cart.js') && response.ok) {
        const clone = response.clone();
        clone.json().then((data) => {
          // Only trigger if not already processing
          if (!isWinbackRunning) {
            initWinback(data);
          }
        });
      }
      return response;
    });
  };

  /**
   * CORE LOGIC
   */
  async function initWinback(cart) {
    isWinbackRunning = true; // Set Lock

    try {
      const items = cart.items || [];
      const rumpItem = items.find(item => item.variant_id == RUMP_VARIANT_ID && item.properties?._FREE_WINBACK_ITEM === 'true');
      const wagyuItem = items.find(item => item.variant_id == WAGYU_VARIANT_ID && item.properties?._FREE_WINBACK_ITEM === 'true');
      
      const rumpCodeObj = cart.discount_codes?.find(d => d.code.startsWith(PREFIX_RUMP));
      const wagyuCodeObj = cart.discount_codes?.find(d => d.code.startsWith(PREFIX_WAGYU));
      const off20CodeObj = cart.discount_codes?.find(d => d.code.startsWith(PREFIX_OFF20));

      const rumpExpired = rumpCodeObj && is2026PromoExpired(rumpCodeObj.code);
      const wagyuExpired = wagyuCodeObj && is2026PromoExpired(wagyuCodeObj.code);
      const off20Expired = off20CodeObj && is2026PromoExpired(off20CodeObj.code);

      // --- RUMP LOOP PROTECTION & REMOVAL ---
      const rumpAttemptKey = rumpCodeObj ? `WB_RUMP_FAILED_${cart.token}_${rumpCodeObj.code}` : null;
      const rumpHasFailedBefore = rumpAttemptKey && localStorage.getItem(rumpAttemptKey);

      if (rumpItem) {
        // Validation: Shopify allocates discounts to item level for product-based codes
        const hasDiscount = rumpItem.line_level_discount_allocations && rumpItem.line_level_discount_allocations.length > 0;
        
        if (!hasDiscount) {
          console.log('Winback: Rump not discounted. Flagging and removing.');
          if (rumpAttemptKey) localStorage.setItem(rumpAttemptKey, 'true');

          showPromoEndedModal('WB_PROMO_ENDED', cart.token);
          await removeItem(rumpItem.key);
          return; // Exit after removal
        }
      } else if (rumpCodeObj && !rumpExpired && !rumpHasFailedBefore) {
        console.log('Winback: Adding Rump...');
        await window.stockmansteaks.addItem({
          variantId: RUMP_VARIANT_ID,
          quantity: 1,
          properties: { _FREE_WINBACK_ITEM: 'true' },
          ignoreAddonsModal: 1
        });
        return; // Exit after adding
      }

      // --- WAGYU LOOP PROTECTION & REMOVAL ---
      const wagyuAttemptKey = wagyuCodeObj ? `WB_WAGYU_FAILED_${cart.token}_${wagyuCodeObj.code}` : null;
      const wagyuHasFailedBefore = wagyuAttemptKey && localStorage.getItem(wagyuAttemptKey);

      if (wagyuItem) {
        // Validation: Shopify allocates discounts to item level for product-based codes
        const hasDiscount = wagyuItem.line_level_discount_allocations && wagyuItem.line_level_discount_allocations.length > 0;
        
        if (!hasDiscount) {
          console.log('Winback: Wagyu not discounted. Flagging and removing.');
          if (wagyuAttemptKey) localStorage.setItem(wagyuAttemptKey, 'true');

          showPromoEndedModal('WB_PROMO_ENDED', cart.token);
          await removeItem(wagyuItem.key);
          return; // Exit after removal
        }
      } else if (wagyuCodeObj && !wagyuExpired && !wagyuHasFailedBefore) {
        console.log('Winback: Adding Wagyu...');
        await window.stockmansteaks.addItem({
          variantId: WAGYU_VARIANT_ID,
          quantity: 1,
          properties: { _FREE_WINBACK_ITEM: 'true' },
          ignoreAddonsModal: 1
        });
        return; // Exit after adding
      }

      // --- EXPIRY & SUCCESS UI ---
      if (off20Expired) {
        const storageKey = 'WB_PROMO_ENDED';
        if (localStorage.getItem(storageKey) !== cart.token) {
          showPromoEndedModal(storageKey, cart.token);
        }
      }

      const isRumpValid = rumpItem && rumpItem.line_level_discount_allocations?.length > 0;
      const isWagyuValid = wagyuItem && wagyuItem.line_level_discount_allocations?.length > 0;
      const isOff20Valid = cart.cart_level_discount_applications?.some(d => 
        d.key.startsWith(PREFIX_OFF20) || (d.title && d.title.startsWith(PREFIX_OFF20))
      );

      if (isRumpValid || isWagyuValid || isOff20Valid) {
        const appliedTypes = [];
        if (isRumpValid) {
          appliedTypes.push(DISCOUNTS.RUMP);
        }
        if (isWagyuValid) {
          appliedTypes.push(DISCOUNTS.WAGYU);
        }
        if (isOff20Valid) {
          appliedTypes.push(DISCOUNTS.OFF20);
        }

        const combinedKey = `WB_SUCCESS_${appliedTypes.join('_')}`;
        if (localStorage.getItem(combinedKey) !== cart.token) {
          showCombinedModal(appliedTypes, combinedKey, cart.token);
        }
      }
    } finally {
      // Release lock after a short delay to allow cart state to settle
      setTimeout(() => { isWinbackRunning = false; }, 500);
    }
  }

  async function removeItem(key) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    });
    window.location.reload();
  }

  /**
   * UI LOGIC
   */
  function showCombinedModal(types, storageKey, cartToken) {
    const $modal = $('#modal-winback');
    if (!$modal.length) return;

    let htmlContent = '';
    if (types.includes(DISCOUNTS.RUMP)) {
      htmlContent += `
        <div style="margin-bottom: 20px;">
          <img src="https://stockmansteaks.com.au/cdn/shop/products/p_8586723f-13f7-4260-97a2-9f97c380df45.jpg?v=1678593760" style="display: block; margin: 0 auto; width: 100px; border-radius: 8px;" />
          <p style="margin-top: 10px;">Your <strong>Free Rump Steaks 280g x 2 Pieces</strong> has been added!</p>
        </div>`;
    }
    if (types.includes(DISCOUNTS.WAGYU)) {
      htmlContent += `
        <div style="margin-bottom: 20px;">
          <img src="https://stockmansteaks.com.au/cdn/shop/products/p_4715048d-cdbf-48cb-8278-861501fefded.jpg?v=1678593760" style="display: block; margin: 0 auto; width: 100px; border-radius: 8px;" />
          <p style="margin-top: 10px;">Your <strong>Free 4-pack of Wagyu Burgers</strong> has been added!</p>
        </div>`;
    }
    if (types.includes(DISCOUNTS.OFF20)) {
      if (types.includes(DISCOUNTS.WAGYU)) htmlContent += '<hr style="border: 0; border-top: 1px solid #eee; margin: 15px 0;">';
      htmlContent += `<div><strong style="font-size: 28px; color: #e02324;">$20 OFF</strong><p>Discount applied to your order!</p></div>`;
    }

    $modal.find('.modal-mini__heading').html('Special Offer Applied!');
    $modal.find('.modal-mini__body div').html(htmlContent);

    if (window.modalMini) {
      window.modalMini.toggleModal($modal, true);
      if (typeof confetti === 'function') {
        confetti({ particleCount: 200, spread: 80, origin: { y: 0.6 } });
      }
      localStorage.setItem(storageKey, cartToken);
    }
  }

  function showPromoEndedModal(storageKey, cartToken) {
    const $modal = $('#modal-winback');
    if (!$modal.length) return;
    
    $modal.find('.modal-mini__heading').html('Offer Expired');
    $modal.find('.modal-mini__body div').html('<p>This specific winback offer is no longer available.</p>');
    
    if (window.modalMini) {
      window.modalMini.toggleModal($modal, true);
      localStorage.setItem(storageKey, cartToken);
    }
  }
})();